import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecunmusersetmealprojectitem/cecUnmUserSetMealProjectItem/save',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecunmusersetmealprojectitem/cecUnmUserSetMealProjectItem/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecunmusersetmealprojectitem/cecUnmUserSetMealProjectItem/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecunmusersetmealprojectitem/cecUnmUserSetMealProjectItem/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecunmusersetmealprojectitem/cecUnmUserSetMealProjectItem/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecunmusersetmealprojectitem/cecUnmUserSetMealProjectItem/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecunmusersetmealprojectitem/cecUnmUserSetMealProjectItem/import',
      method: 'post',
      data: data
    })
  }
}
